<template>
  <Bar
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Bar } from "vue-chartjs/legacy";
import ChartDataLabels from "chartjs-plugin-datalabels";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
 
} from "chart.js";
import { roundUp } from "../utility/roundUp";


ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
 
);

export default {
  bau1:'',
  bau2:'',
  der1:'',
  der2:'',
  name: "GroupedBarChartNew",
  components: {
    Bar,
  },
  props: {
    datasets: {
      type: Array,
    },
    labels: {
      type: Array,
    },
    chartId: {
      type: String,
      default: "bar-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 50,
    },
    height: {
      type: Number,
      default: 200,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [ChartDataLabels],
    },
  },
  data() {
    console.log("dataset from x", this.datasets)
    this.bau1 = roundUp(this.datasets[0].data[0],2);
    this.bau2 = roundUp(this.datasets[0].data[1],2);
    this.der1 = roundUp(this.datasets[1].data[0],2);
    this.der2 = roundUp(this.datasets[1].data[1],2);
    this.datasets[0].data[0] = this.bau1;
    this.datasets[0].data[1] = this.der1;
    this.datasets[1].data[0] = this.bau2;
    this.datasets[1].data[1] = this.der2;
    return {
      chartData: {
        labels: ["BAU", "DER"],
        datasets: this.datasets,
        
      },
      chartOptions: {
       scales:{
          x:{
             ticks: {
              font: {
                weight: 'bold'
              }
            },
          }
        },
        plugins: {
          legend: {
            display: false,
          },
          datalabels: {
            formatter: function (value, context) {
              return roundUp(new Intl.NumberFormat("en-US").format(value),2);
            }
               
          },
         
        },
     layout: {
              padding: {
                  left: 10,
                  right: 10,
                  top: 30,
                  bottom: 10
              }
              },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
};
</script>
